import script from "./OrdersListCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersListCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__